import React, { useState, useRef } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import '../../App.css'
import TDSConfigurationTable from '../table-data/TDSConfigurationTable';
import AddTDSConfigurationForm from './AddTDSConfigurationForm';
import Popup from '../Popup';

function TDS_Configuration() {
    const [openPopup, setOpenPopup] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const tableRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleCloseModal = () => {
        setOpenPopup(false);
    };

    const handleRefresh = () => {
        // Trigger table refresh
        if (tableRef.current && tableRef.current.refreshTable) {
            tableRef.current.refreshTable();
        }
        // Also trigger refresh via key change as backup
        setRefreshKey(prev => prev + 1);
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
            <Paper elevation={5} sx={{ width: "60.5%", maxWidth: "1400px" }}>
                <Grid className="form-title" style={{ marginBottom: "-60px" }} container spacing={2}>
                    <Grid item>
                        <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
                            TDS Configuration
                        </Typography>
                    </Grid>
                    <Grid item>
                        <HiOutlineCurrencyRupee size={45} style={{ marginLeft: "-50px" }} />
                    </Grid>
                </Grid>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <Stack spacing={2} sx={{ margin: "33px" }}>
                        <Stack display="flex" sx={{ alignItems: "flex-end", marginRight: "30px" }}>
                            <Button
                                style={{ width: "200px" , marginRight: "60px" }}
                                className="form-btn"
                                variant="outlined"
                                color="success"
                                onClick={() => setOpenPopup(true)}
                                startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
                                sx={{
                                    whiteSpace: "nowrap",
                                    textTransform: "none"
                                }}
                            >
                                Add TDS Configuration
                            </Button>
                        </Stack>

                        <TDSConfigurationTable ref={tableRef} refreshKey={refreshKey} />

                    </Stack>
                </form>

                <Popup
                    title="Add TDS Configuration"
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <AddTDSConfigurationForm 
                        onCloseModal={handleCloseModal}
                        setOpenPopup={setOpenPopup}
                        onRefresh={handleRefresh}
                    />
                </Popup>
            </Paper>
        </Box>
    );
}

export default TDS_Configuration;

